import { render } from "./position.vue?vue&type=template&id=6709beca&scoped=true"
const script = {}

import "./position.vue?vue&type=style&index=0&id=6709beca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\97813\\Desktop\\汇智衣\\sd_hq_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6709beca"]])

export default __exports__